var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.974,
    height: 86,
    viewBox: "0 0 85.974 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(-909 -87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-158 371.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "success",
    transform: "translate(1067 -284.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(10.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M175.4,102.938a16.218,16.218,0,1,0,16.218,16.218A16.236,16.236,0,0,0,175.4,102.938Z",
    transform: "translate(-143.329 -85.117)",
    fill: "#b0342d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M65.077,0V47.838L97.171,68.079,129.222,48.4V0ZM97.1,54.759A21.256,21.256,0,1,1,118.353,33.5,21.28,21.28,0,0,1,97.1,54.759Z",
    transform: "translate(-65.077)",
    fill: "#b0342d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M5.333,16V10.667H0V5.333H5.333V0h5.333V5.333H16v5.333H10.667V16Z",
    transform: "translate(32.168 22.821) rotate(45)",
    fill: "#feefef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0 29.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M43.046,310.485.077,283.385V321.8H86.051V284.076Z",
    transform: "translate(-0.077 -265.663)",
    fill: "#b0342d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M5.954,177.845.077,182.366v6.6l5.877,3.707Z",
    transform: "translate(-0.077 -177.845)",
    fill: "#b0342d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M477.077,177.845V193.31l5.877-3.609v-7.335Z",
    transform: "translate(-396.98 -177.845)",
    fill: "#b0342d"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadError);
export default __webpack_public_path__ + "static/media/upload-error.fa469d99428657d9ffa2c8194e61bc15.svg";
export { ForwardRef as ReactComponent };